import React from 'react';
// ✅ Import the SVG file
import logoSrc from '../../assets/images/logo.png'; 

const Logo = ({ className = "h-10 w-auto" }) => {
  return (
    <div className="flex items-center gap-2">
      <img 
        src={logoSrc} 
        alt="iTalebTech Logo" 
        className={className} 
      />
      {/* Optional: If logo includes text, remove this h1 */}
      {/* <h1 className="font-bold text-xl tracking-tighter text-gray-900">
        iTaleb<span className="text-indigo-600">Tech</span>
      </h1> */}
    </div>
  );
};

export default Logo;